import { render } from "./SwiperSquareItem.vue?vue&type=template&id=645821e0&ts=true"
import script from "./SwiperSquareItem.vue?vue&type=script&lang=ts"
export * from "./SwiperSquareItem.vue?vue&type=script&lang=ts"

import "./SwiperSquareItem.vue?vue&type=style&index=0&id=645821e0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__